/* nplus-electrify-expo.js — <nplus-allocation-form> element.
   Allocation-inquiry landing form: product + variant dropdowns, contact + billing.
   Loaded after nplus-leasing-service.js. Uses window.nplusLeasing.createLeasingInquiry.
   Mirrors assets/nplus-leasing.js; does NOT modify it. */
(function () {
  'use strict';

  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  var BILLING_REQUIRED = ['address1', 'city', 'province', 'zip', 'country'];

  class NplusAllocationForm extends HTMLElement {
    connectedCallback() {
      if (this._connected) return; // guard against duplicate listeners on DOM re-insertion
      this._connected = true;

      var cfgEl = this.querySelector('.nplus-allocation__config');
      try { this.cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { this.cfg = {}; }

      var prodEl = this.querySelector('[data-nplus-products]');
      try { this.products = JSON.parse(prodEl ? prodEl.textContent : '[]'); } catch (e) { this.products = []; }

      var self = this;
      this.fields = {};
      Array.prototype.forEach.call(this.querySelectorAll('[data-nplus-field]'), function (el) {
        self.fields[el.getAttribute('data-nplus-field')] = el;
      });
      this.billing = {};
      Array.prototype.forEach.call(this.querySelectorAll('[data-nplus-billing]'), function (el) {
        self.billing[el.getAttribute('data-nplus-billing')] = el;
      });
      this.consentEl = this.querySelector('[data-nplus-consent]');
      var label = this.querySelector('[data-nplus-consent-label]');
      if (label) label.textContent = this.cfg.consentLabel || 'I consent.';
      this.submitEl = this.querySelector('[data-nplus-submit]');
      this.statusEl = this.querySelector('[data-nplus-status]');
      this.variantWrap = this.querySelector('[data-nplus-variant-wrap]');

      if (this.fields.product) this.fields.product.addEventListener('change', this.onProductChange.bind(this));
      if (this.submitEl) this.submitEl.addEventListener('click', this.onSubmit.bind(this));
    }

    t(key, fallback) { return (this.cfg && this.cfg.i18n && this.cfg.i18n[key]) || fallback; }

    findProduct(id) {
      for (var i = 0; i < this.products.length; i++) {
        if (String(this.products[i].id) === String(id)) return this.products[i];
      }
      return null;
    }

    onProductChange() {
      var sel = this.fields.variant;
      var wrap = this.variantWrap;
      if (!sel) return;
      sel.innerHTML = '';
      var p = this.findProduct(this.fields.product.value);
      if (!p || !p.variants || !p.variants.length) {
        sel.disabled = true;
        if (wrap) wrap.hidden = true;
        return;
      }
      var self = this;
      p.variants.forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.available ? v.title : v.title + ' (' + self.t('unavailable', 'unavailable') + ')';
        if (!v.available) opt.disabled = true;
        sel.appendChild(opt);
      });
      sel.disabled = false;
      // Single variant: auto-select and keep the select hidden to reduce friction.
      if (p.variants.length === 1) {
        sel.value = p.variants[0].id;
        if (wrap) wrap.hidden = true;
      } else {
        sel.value = '';
        if (wrap) wrap.hidden = false;
      }
    }

    setStatus(msg, isError) {
      if (!this.statusEl) return;
      this.statusEl.textContent = msg || '';
      this.statusEl.hidden = !msg;
      this.statusEl.classList.toggle('nplus-bb__status--error', !!isError);
    }
    setBusy(b) { if (this.submitEl) { this.submitEl.disabled = b; this.submitEl.setAttribute('aria-busy', b ? 'true' : 'false'); } }

    showFieldError(key, msg) {
      var el = this.querySelector('[data-nplus-error-for="' + key + '"]');
      if (el) { el.textContent = msg || this.t('required', 'Required'); el.hidden = false; }
    }
    clearFieldErrors() {
      Array.prototype.forEach.call(this.querySelectorAll('[data-nplus-error-for]'), function (e) { e.hidden = true; });
    }

    collect() {
      var f = this.fields, b = this.billing;
      var val = function (el) { return el ? el.value.trim() : ''; };
      return {
        productId: val(f.product),
        variantId: val(f.variant),
        customer: { firstName: val(f.firstName), lastName: val(f.lastName), email: val(f.email), phone: val(f.phone) },
        billing: { address1: val(b.address1), address2: val(b.address2), city: val(b.city), province: val(b.province), zip: val(b.zip), country: val(b.country) },
        consent: !!(this.consentEl && this.consentEl.checked),
        currency: this.cfg.presentmentCurrency,
        locale: this.cfg.locale,
        // Allocation form collects no employer; opt out of that requirement and
        // tag the draft so these inquiries are distinguishable in the admin.
        employerOptional: true,
        source: 'electrify-expo'
      };
    }

    validate(payload) {
      this.clearFieldErrors();
      var ok = true;
      var fail = function (key, msg) { ok = false; this.showFieldError(key, msg); }.bind(this);
      if (!payload.productId) fail('product', this.t('select_model', 'Select a model'));
      if (!payload.variantId) fail('variant', this.t('select_variant', 'Select an option'));
      var c = payload.customer;
      if (!c.firstName) fail('firstName');
      if (!c.lastName) fail('lastName');
      if (!c.email) fail('email'); else if (!EMAIL_RE.test(c.email)) fail('email', this.t('invalid_email', 'Enter a valid email'));
      BILLING_REQUIRED.forEach(function (k) { if (!payload.billing[k]) fail(k); });
      if (!payload.consent) fail('consent', this.t('consent_required', 'Consent is required to submit.'));
      return ok;
    }

    onSubmit() {
      this.setStatus('');
      if (!window.nplusLeasing) { this.setStatus(this.t('unavailable_service', 'Service unavailable. Please refresh.'), true); return; }
      var payload = this.collect();
      if (!this.validate(payload)) return;
      this.setBusy(true);
      var self = this;
      window.nplusLeasing.createLeasingInquiry(payload)
        .then(function () { self.showSuccess(); })
        .catch(function (err) { self.setStatus(err.message || self.t('submit_error', 'Could not submit your inquiry. Please try again.'), true); self.setBusy(false); });
    }

    showSuccess() {
      var title = this.t('success_title', 'Inquiry received');
      var body = this.t('success_body', 'Thanks — your inquiry is in. Our team will be in touch shortly.');
      this.innerHTML = '<div class="nplus-ee__success"><h3>' + title + '</h3><p>' + body + '</p></div>';
    }
  }

  if (!customElements.get('nplus-allocation-form')) {
    customElements.define('nplus-allocation-form', NplusAllocationForm);
  }
})();
